/**
 * Stable browser/provider boundary for the ephemeral ciphertext mailbox.
 *
 * The browser depends on this HTTP contract, not on Vercel APIs. A hosting
 * adapter may implement the same path with a function, worker, edge route or
 * another short-lived cache-backed handler.
 */
export const RELAY_MAILBOX_PATH = "/api/mailbox";
export const RELAY_MAILBOX_WRITE_HEADER = "X-Relay-Frame";
export const RELAY_MAILBOX_CONTRACT = "browser-local-ciphertext-mailbox-v1";
export const RELAY_MAILBOX_TTL_SECONDS = 120;
export const RELAY_MAILBOX_MAX_FRAME_BYTES = 12 * 1024;
export const RELAY_CLIENT_FRAME_LIMIT_BYTES = 10_000;

export function resolveSameOriginRelayEndpoint(endpoint: string, applicationUrl: string): string {
  const application = new URL(applicationUrl);
  const resolved = new URL(endpoint, application);
  if (resolved.origin !== application.origin) {
    throw new Error("mailbox_endpoint_must_be_same_origin");
  }
  if (resolved.search || resolved.hash) {
    throw new Error("mailbox_endpoint_must_not_have_query_or_fragment");
  }
  return resolved.toString();
}
